// Import base styles so all base classes are available
@import './../styles.module.scss';
@import '../../../style/globals.scss';

$highight-color: #65e178;
$dark-color: #06240c;

// Dakota theme specific overrides and additions
.MediaViewer.video {
    .overlay {
        background-color: rgba(0, 0, 0, 0.6);
    }

    .modalContent {
        background-color: rgba(0, 20, 6, 0.7);
    }

    .closeButton {
        background-color: $highight-color;

        svg {
            path {
                fill: black;
            }
        }
    }

    .mediaContainer {
        // Image must have 16/9 space inside
        // background-image is set dynamically via JS from theme.customJSON.mediaViewer.videoBorderImageUrl
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;

        .videoWrapper {
            // Height needed for background to be seen
            height: 70%;

            // Aspect ratio of the whole border image
            @media (max-aspect-ratio: 2858/1492) {
                // Width needed for background to be seen
                width: 65%;
                height: auto;
            }

            .roundVideoProgressBar {
                background-color: $dark-color;
                color: $highight-color;

                circle:nth-child(2) {
                    stroke: $highight-color;
                }
            }

            .completionText {
                background-color: $dark-color;
                color: $highight-color;
            }
        }

        // Make 100% width on mobile
        @media (max-width: $bp-xs) {
            background-size: cover;

            @media (max-height: 433px) {
                // If this small just hide it
                background-image: none !important;
            }

            .videoWrapper {
                height: 100%;
                width: auto;

                @media (max-aspect-ratio: 16/9) {
                    width: 100%;
                    height: auto;
                }
            }
        }
    }
}
